import { authServiceApi } from "../../../../app/authServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../../types";
import {
  AllAttendanceParams,
  AttendanceSettingsResponse,
  DailyAttendanceSettingsResponse,
} from "./attendanceManagement.type";

export const attendanceManagementApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // ------ Mutations ------
    upsertAttendanceSettings: builder.mutation({
      query: ({ data }) => {
        return {
          url: API_URL.attendanceSettings,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: (result) => {
        if (result)
          return ["GetAttendanceSettings", "GetShift"] as unknown as any;
        return [] as unknown as any;
      },
    }),

    // ------ Queries ------
    getAttendanceSettings: builder.query<
      CommonResponse<AttendanceSettingsResponse>,
      GetQueryArgsType<{}>
    >({
      query: (queryArgs) => ({
        url: API_URL.attendanceSettings,
        ...queryArgs,
      }),
      providesTags: ["GetShift"],
    }),

    getDailyAttendanceList: builder.query<
      CommonResponse<DailyAttendanceSettingsResponse>,
      GetQueryArgsType<AllAttendanceParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDailyAttendanceList,
        ...queryArgs,
      }),
      providesTags: ["GetDailyAttendanceList"],
    }),
  }),
});

export const {
  // ------ Mutation Hooks ------
  useUpsertAttendanceSettingsMutation,

  // ------ Query Hooks ------
  useGetAttendanceSettingsQuery,
  useGetDailyAttendanceListQuery,
} = attendanceManagementApi;
